export default __webpack_public_path__ + "static/media/righteye.42f33e87.svg";